import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '../config/localeConfig';

export const SUPPORTED_LANGUAGES = [...SUPPORTED_LOCALES] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export function isSupportedLanguage(lang?: string | null): lang is SupportedLanguage {
  return !!lang && SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage);
}

export function buildLocalizedPath(path = '/', lang = DEFAULT_LOCALE) {
  const cleanPath = typeof path === 'string' && path.trim() ? path.trim() : '/';

  if (cleanPath === '/') return `/${lang}`;

  if (cleanPath.startsWith(`/${lang}/`) || cleanPath === `/${lang}`) {
    return cleanPath;
  }

  const normalized = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
  return `/${lang}${normalized}`;
}

export function stripLanguageFromPath(pathname = '/') {
  const segments = pathname.split('/').filter(Boolean);

  if (!segments.length) {
    return {
      lang: null,
      path: '/',
    };
  }

  const [first, ...rest] = segments;

  if (isSupportedLanguage(first)) {
    return {
      lang: first,
      path: rest.length ? `/${rest.join('/')}` : '/',
    };
  }

  return {
    lang: null,
    path: pathname,
  };
}

export function localizedPath(lang: SupportedLanguage, path = '/') {
  return buildLocalizedPath(path, lang);
}
